var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prolog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Prolog_1_",
    fill: "#755ca4",
    d: "M70.866,2.268C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.866,144 c39.139,0,70.866-31.728,70.866-70.866C141.732,33.996,110.005,2.268,70.866,2.268z M36.297,106.657 c-2.109-2.109,6.679-24.441,15.652-15.468C60.923,100.163,38.407,108.767,36.297,106.657z M91.818,76.953 c-2.164,2.164-3.953,3.887-5.465,5.273l1.909,17.397c0.185,0.743-0.15,1.733-0.925,2.508l-9.166,9.166 c-0.875,0.875-2.022,1.186-2.781,0.82c-0.132-0.063-0.255-0.14-0.358-0.244c-1.803-1.585,1.919-11.65,0.873-13.577l-5.907-5.986 c-7.972,7.151-9.814,4.451-11.272,2.992l-10.77-10.771c-1.459-1.459-4.16-3.3,2.993-11.273l-6.165-6.083 c-1.927-1.046-11.993,2.676-13.578,0.874c-0.104-0.104-0.182-0.228-0.244-0.359c-0.365-0.759-0.054-1.906,0.821-2.781l9.166-9.166 c0.774-0.774,1.764-1.11,2.507-0.925l17.401,1.91c1.394-1.522,3.12-3.315,5.27-5.465c13.798-13.798,35.93-16.867,39.245-13.553 C108.995,41.333,105.616,63.155,91.818,76.953z M85.417,52.25c-3.037,0-5.5,2.462-5.5,5.5s2.463,5.5,5.5,5.5s5.5-2.462,5.5-5.5 S88.454,52.25,85.417,52.25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProlog);
export default __webpack_public_path__ + "static/media/prolog.c129bed6.svg";
export { ForwardRef as ReactComponent };